var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0958 9.54062L16.2167 9.18229C17.2677 8.84687 18.3906 9.38958 18.8406 10.45L19.7365 12.5625C20.126 13.4823 19.9094 14.5646 19.201 15.2375L17.2271 17.1104C17.349 18.2312 17.726 19.3344 18.3573 20.4198C18.9567 21.4699 19.7608 22.3891 20.7219 23.1229L23.0927 22.3313C23.9906 22.0323 24.9698 22.3771 25.5198 23.1865L26.8042 25.0719C27.4448 26.0135 27.3292 27.3115 26.5344 28.1094L25.6833 28.9646C24.8354 29.8156 23.624 30.125 22.5042 29.775C19.8583 28.95 17.4281 26.501 15.2094 22.4281C12.9875 18.349 12.2031 14.8865 12.8573 12.0448C13.1323 10.849 13.9833 9.89583 15.0958 9.54062V9.54062Z",
    fill: "#222222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhn);
export default __webpack_public_path__ + "static/media/phn.c663877afecd430f8b51550c063600fd.svg";
export { ForwardRef as ReactComponent };